import { useTranslation } from 'react-i18next';
import { Modal } from '@kep-ui-kit/ui-components';
import styled from '@emotion/styled';

import { StyledButton, StyledText } from './styled-components';

export const StyledModalContainer = styled.div(
  ({ theme }: { theme?: any }) => ({
    width: '100%',
    padding: '40px 40px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
    },
  })
);

export const ButtonContainer = styled.div(({ theme }: { theme?: any }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

export const StyledModalTitle = styled(StyledText)(
  ({ theme }: { theme?: any }) => ({
    fontSize: theme.typography.pxToRem(24),
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: theme.typography.pxToRem(24),
    wordBreak: 'break-word',
  })
);

const StyledErrorText = styled(StyledText)`
  text-align: center;
  margin-bottom: 40px;
  word-break: break-word;
  white-space: pre-line;
`;

const StyledModalButton = styled(StyledButton)`
  display: flex;
  &:nth-of-type(2) {
    margin-left: 16px;
  }
`;

interface Props {
  onClose: () => void;
  onDissmiss: () => void;
  errorTitle: string;
  errorText: string;
  open: boolean;
  withDissmiss: boolean;
  dismissBtnText: string;
  confirmBtnText: string;
  dismissBtnId: string;
  confirmBtnId: string;
}

export const ErrorModal = ({
  onClose,
  errorTitle,
  errorText,
  open,
  withDissmiss,
  onDissmiss,
  dismissBtnText,
  confirmBtnText,
  dismissBtnId,
  confirmBtnId,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      maxWidth="sm"
      backdropColor="rgba(0,110,250,.8)"
      fullWidth
      open={open}
    >
      <StyledModalContainer>
        <StyledModalTitle className="dialog-title">
          {errorTitle || t('common.something-went-wrong')}
        </StyledModalTitle>
        <StyledErrorText className="dialog-message">
          {/* eslint-disable-next-line no-irregular-whitespace */}
          {errorText?.replace(/ /g, ' ') || t('common.something-went-wrong-try-later')}
        </StyledErrorText>
        <ButtonContainer>
          {withDissmiss && (
            <StyledModalButton
              className="p-button-label"
              id={dismissBtnId}
              size="large"
              onClick={onDissmiss}
              withoutMargin
              isBorderless
            >
              {dismissBtnText}
            </StyledModalButton>
          )}
          <StyledModalButton
            className="p-button-label"
            id={confirmBtnId}
            size="large"
            onClick={withDissmiss ? onClose : onDissmiss}
            withoutMargin
          >
            {confirmBtnText}
          </StyledModalButton>
        </ButtonContainer>
      </StyledModalContainer>
    </Modal>
  );
};
